<template>
  <div class="w-100 root d-inline-block">
   <!-- <div class="input-group">
      <div v-if="mode==='view'">
        <div v-if="user.haveCompanyPost">
          <button class="btn btn-secondary" @click="openModal('view')">
            <i class="icon-eye-outline"></i>
          </button>
        </div>
        <div v-if="!user.haveCompanyPost">ندارد</div>
      </div>
      &lt;!&ndash; <input v-if="mode!=='view'" class="form-control" @click="openModal"> &ndash;&gt;
      <button v-if="mode==='create'" class="btn btn-success" @click="openModal('create')">
        <i class="icon-content-duplicate"></i>
      </button>
      <button v-if="mode==='edit' && user.id" class="btn btn-secendory" @click="openModal('edit')">
        <i class="icon-bd-pencil"></i>
      </button>
    </div>-->

    <div class="row mt-2">
      <div class="col-6 text-center">
        <b-form-radio v-model="selectedValue" name="check" @change="companyCheckboxChanged" value="outsource">شرکت های خارجی</b-form-radio>
      </div>
      <div class="col-6 text-center">
        <b-form-radio v-model="selectedValue" name="check" @change="companyCheckboxChanged" value="company">شرکت های داخلی</b-form-radio>
      </div>
      <div class="col-6 mt-2">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>نام</span>
            </div>
          </div>
          <!--<input v-model="server.name" type="text" class="form-control">-->
          <input v-model="firstName" type="text" class="form-control" :readonly="readable === true">
        </div>
      </div>
      <div class="col-6 mt-2">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>نام خانوادگی</span>
            </div>
          </div>
          <!--<input v-model="server.name" type="text" class="form-control">-->
          <input v-model="lastName" type="text" class="form-control" :readonly="readable === true">
        </div>
      </div>
      <div class="col-6 mt-2">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>نام کاربری</span>
            </div>
          </div>
          <!--<input v-model="server.name" type="text" class="form-control">-->
          <input v-model="userName" type="text" class="form-control" :readonly="readable === true">
        </div>
      </div>
      <div class="col-6 mt-2">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>رمزعبور</span>
            </div>
          </div>
          <!--<input v-model="server.name" type="text" class="form-control">-->
          <input v-model="password" type="password" class="form-control" :readonly="readable === true" @change="checkPasswordLenght(password)">
        </div>
      </div>
      <div class="col-6 mt-2">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>شرکت</span>
            </div>
          </div>
          <!--<input v-model="server.name" type="text" class="form-control">-->
          <vs-select
            ref="companies"
            :data="companyName"
            :header="{label: vsSelectLabel}"
            :mode="'edit'"
            :is-header="true"
            :selected-val="companySelectedVal"
            @onChange="onCompanyChange"
          ></vs-select>
        </div>

      </div>
      <div class="col-6 mt-2">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>سمت</span>
            </div>
          </div>
          <!--<input v-model="server.name" type="text" class="form-control">-->
          <vs-select
            ref="posts"
            :data="userRoles"
            :header="{label:'name'}"
            :mode="'edit'"
            :is-header="true"
            :selected-val="rolesSelectedVal"
            @onChange="onUserRolesChange"
          ></vs-select>
        </div>
      </div>
      <div class="col-12 text-center mt-2">
        <button class="btn iconed btn-secondary" id="btn-order" @click="addToRolesTable"><i
          class="icon-bd-plus"></i><span>افزودن به جدول</span></button>
      </div>
    </div>
    <vs-table v-if="show" ref="userRoleTable" :params="tableParams" :options="tableOptions"></vs-table>
  </div>
</template>

<script>
  import { mapState, mapMutations, mapActions } from "vuex";
  import BaseService from "../_framework/api/BaseService.js";
  import Utils from "../_framework/utils/Utils.js";
  import VsSelect from "../_framework/VsSelect";
  import VsTableMixin from "../_framework/VsTableMixin.js";
  import DatePicker from "../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue";
  import Products from "../pages/Products.vue";
  import EventBus from "../bus.js";
  export default {
    name: "add-person",
    props: {
      headerKey: null,
      row: null,
      mode: {
        default: "view",
        type: String
      },
    },
    mixins: [VsTableMixin],
    components: {
      VsSelect,
      datePicker: DatePicker
    },
    data() {
      return {
        userModel: {},
        readable: false,
        isCompany: true,
        isOutSource: true,
        firstName: null,
        lastName: null,
        userName: null,
        password: null,
        vsSelectLabel: '',
        companySelectedVal: null,
        rolesSelectedVal: null,
        userRoles: [],
        companyName: [],
        companySelectedName: '',
        postName: '',
        company: '',
        show: true,
        user: {},
        documentDate: null,
        servicesList: [],
        selectedServices: [],
        selectedValue: '',
        service: {
          id: 0,
          title: "",
          price: "",
          sessionQuantity: "",
          description: ""
        },
        posts: [],
        currentPost: {
          postId: 0,
          companyId: null,
          outSourceId: null
        },
        tableParams: {
          list: [],
          entity: "CompanyUserPost",
          headers: {
            /*firstName: {
              title: "نام",
              type: "text",
              rowAlignment: "center"
            },
            lastName: {
              title: "نام خانوادگی",
              type: "text",
              rowAlignment: "center"
            },
            userName: {
              title: "نام کاربری",
              type: "text",
              rowAlignment: "center"
            },
            password: {
              title: "رمز عبور",
              type: "text",
              rowAlignment: "center"
            },*/
            company: {
              title: "نام شرکت",
              type: "text",
              rowAlignment: "center"
            },
            post: {
              title: "سمت",
              type: "text",
              rowAlignment: "center"
            },
          }
        },
        tableOptions: {
          dataSourceType: "store",

          beforeCreateEntity: input => {

            if (this.mode === "create") {
              this.insertRow(input);
              return null;
            } else {
              if (input && input["material"]) {
                input["material"] = input["material"].id;
              }

              input.userId = this.user.id;
              input.postId = input.post.id;
              input.companyId = input.company.id;
              input.outSourceId = input.company.id;
              input = {
                userId: input.userId,
                postId: input.post.id,
                companyId: input.company.id,
                outSourceId: input.company.id
                // id: this.$refs.userRoleTable.$data.list.data[0].id
              };
              return input;
            }
          },
          beforeUpdateEntity: input => {
            if (this.mode === "create") {
              this.insertRow(input);
              return null;
            } else {
              input = {
                userId: input.user.id,
                postId: input.post.id,
                companyId: input.company.id,
                outSourceId: input.company.id,
                id: input.id
              };
              return input;
            }
          },
          // beforeDeleteEntity: input => {
          //   if (this.mode === "create") {
          //     this.deleteuserRoleTableRow(input.id);
          //     return null;
          //   } else {
          //     return input;
          //   }
          // },
          beforeFetchEntityList: input => {
            if (this.user && this.user.id) input.userId = this.user.id;
            return input;
          },
          hasActions: false,
          onRowClicked: row => {},
          hasActionsInHeader: false,
          clickableRows: true,
          // onEditClicked: (row, context) => {
          //   this.productVoucherModel = row;
          //   this.productVoucherModel.type = "Edit";
          //   this.openProductDetailModal();
          // },
          onRowDoubleClicked: row => {
            //   this.productVoucherModel.type = "View";
            //   this.productVoucherModel = row;
            //   this.openProductDetailModal();
          }
        }
      };
    },
    mounted() {},
    beforeMount() {
      if (this.row) {
        this.user = this.row;
      }
      this.tableOptions.access = checkAccess(this.$route.path);
    },
    methods: {
      checkPasswordLenght(value) {
        let passwordLenght = value.length;
        if(passwordLenght < 6) {
          this.$noty.error("کلمه عبور باید بیشتر از 6 کاراکتر باشد")
        }
      },
      sendObjectToParent() {
        this.userModel = {
          firstName: this.firstName,
          lastName: this.lastName,
          userName: this.userName,
          password: this.password,
          posts: this.posts
        }
        this.$emit('add-person', this.userModel);
        this.$emit('createNewUser', this.resetUserForm);
      },
      lockInputs() {
        this.$refs.posts.$data.selectedValue = null;
        this.$refs.companies.$data.selectedValue = null;
        this.readable = true;
      },
      resetUserForm() {
        this.$refs.posts.$data.selectedValue = null;
        this.$refs.companies.$data.selectedValue = null;
      },
      getCompanies() {
        if ( this.isOutSource === true && this.isCompany === false) {
          this.vsSelectLabel = "outSourceName"
          new BaseService('OutSource').getList().then((response) => {
            // console.log(response.data);
            this.companyName = response.data;

          }).catch((error) => {
            console.log(error)
          })
        } else if (this.isCompany === true && this.isOutSource === false) {
          this.vsSelectLabel = "companyName"
          new BaseService('company', '/getAll').getList().then((response) => {
            // console.log(response.data);
            this.companyName = response.data;

          }).catch((error) => {
            console.log(error)
          })
        }


      },
      getAccesses() {
        new BaseService('access', '/GetAsDropdown').getList().then((response) => {
          // console.log(response.data)
          this.userRoles = response.data;
        }).catch((error) => {
          console.log(error)
        })

      },
      onCompanyChange(val) {

        if (this.isCompany === false && this.isOutSource === true ) {
          if (val !== null) {
            this.company = val.outSourceName;
            this.currentPost.outSourceId = val.id;
            this.currentPost.companyId = null;
          }

        } else if (this.isCompany === true && this.isOutSource === false) {
          if (val !== null) {
            this.company = val.companyName;
            this.currentPost.companyId = val.id;
            this.currentPost.outSourceId = null
          }
        }

      },
      onUserRolesChange(val) {
        // console.log(val.name)
        if (val !== null) {
          this.currentPost.postId = val.id;
          this.postName = val.name;
        }

      },
      addToRolesTable() {

        let postsModel = {
          postId: this.currentPost.postId,
          companyId: this.currentPost.companyId,
          outSourceId: this.currentPost.outSourceId
        };
        this.$store.commit("ADD_ROW_TO_VS_TABLE_FEED", {
          /*firstName: this.firstName,
          lastName: this.lastName,
          userName: this.userName,
          password: this.password,*/
          post: this.postName,
          company: this.company
        });
        this.posts.push(postsModel);
        this.lockInputs();
        this.sendObjectToParent();
      },
      companyCheckboxChanged(val) {
        if (val === 'outsource') {
          // this.tableParams.headers.company.listParams.requestURI = 'OutSource';
          this.tableParams.headers.company.label = 'outSourceName';
          this.isOutSource = true;
          this.isCompany = false;
          this.getCompanies();
          this.getAccesses();

        } else {
          // this.tableParams.headers.company.listParams.requestURI = 'company/getAll';
          this.tableParams.headers.company.label = 'companyName';
         this.isCompany = true;
         this.isOutSource = false;
          this.getCompanies();
          this.getAccesses();
        }
      },
      openModal(mode) {
        this.tableOptions.headerActionsMode = mode;
        if (mode === "create") {
          this.tableOptions.clearStoreOnMount = true;
          this.tableOptions.dataSourceType = "store";
          this.tableOptions.hasActions = false;
          this.tableOptions.hasActionsInHeader = false;
        } else {
          this.$store.commit("REMOVE_ALL_ROWS_FROM_VS_TABLE_FEED");
          this.tableOptions.dataSourceType = "api";
          if (mode === "view") {
            this.tableOptions.hasActions = false;
            this.tableOptions.hasActionsInHeader = false;
          } else {
            this.tableOptions.hasActions = false;
            this.tableOptions.hasActionsInHeader = false;
          }
        }
        this.$refs.userRoleModal.show();
        this.$refs.userRoleTable.onFetchEntityListRequested();
        this.refreshuserRoleTable();
      },
      setDateFromDatePicker(date) {
        this.documentDate = date;
      },
      toggleDatePicker() {
        this.$refs.datePicker.togglePicker();
      },
      btnClicked() {
        this.$refs.userRoleModal.show();
        this.calculatePrependWidth();
      },
      /*onUserRoleModalOk() {
        this.$emit(
          "dataChanged",
          this.posts,
          this.vsTableFeed.map(m => {
            return m;
          })
        );
        /!*new BaseService('CompanyUserPost').create().then((response) => {

        }).catch((error) => {
          console.log(error)
        })*!/
      },*/
      /*insertRow(data) {
        this.$store.commit("ADD_ROW_TO_VS_TABLE_FEED", {
          id: Math.round(Math.random() * 1000),
          company: data.company,
          post: data.post
        });
        // this.voucherModel.voucherProductDto.push({
        //   productId: data.productId,
        //   unitVal: data.number || data.unitVal,
        //   price: data.price,
        //   productName: data.productName
        // });
      },*/
      deleteuserRoleTableRow(id) {
        // this.$store.commit("DELETE_ROW_FROM_VS_TABLE_FEED", id);
        this.$store.commit(
          "RESET_VS_TABLE_FEED",
          this.vsTableFeed.filter(ur => {
            return ur.id !== id;
          })
        );
        this.show = false;
        setTimeout(() => {
          this.show = true;
        }, 50);
      },
      refreshuserRoleTable() {
        this.$refs.userRoleTable.onFetchEntityList();
        this.show = false;
        setTimeout(() => {
          this.show = true;
        }, 50);
      }
    },
    computed: {
      ...mapState(["selectedRows", "currentService", "vsTableFeed"]),
      modalTitle() {
        if (this.user.userName) {
          return "سمت های " + this.user.userName;
        } else {
          return "سمت ها";
        }
      },
      /* getCompanyRequestUrl() {
         return 'dsfsdf'
       }*/
    },
    watch: {
      vsTableFeed(val) {},
      row(val) {
        this.user = val;
        // this.modalTitle = "محصولات میانی " + this.user.productName;
        if (this.mode === "create") {
          this.tableParams.dataSourceType = "store";
        } else {
          this.tableParams.dataSourceType = "api";
        }
      }
    }
  };
</script>

<style scoped>
  hr {
    background-color: rgba(255, 255, 255, 0.4);
  }

  .input-group > div:not(.custom) {
    display: flex;
    flex: 1;
  }

</style>
